<div class="header-wrapper">
  <span class="title">
    {{ "folders.title" | translate }}
  </span>
  <button class="add" (click)="createFolder()" [disabled]="isLoading()">
    <mat-icon>add</mat-icon>
    {{ "folders.add" | translate }}
  </button>
</div>

<tree-root [nodes]="nodes" (updateData)="onTreeUpdate()" [options]="options">
  <ng-template #treeNodeWrapperTemplate let-node let-index="index">
    <div class="node-wrapper" [contextMenu]="contextMenuRef" [contextMenuValue]="node.data"
         [style.padding-left]="node.getNodePadding()" [class.node-wrapper-active]="node.isActive"
         [class.node-wrapper-focused]="node.isFocused">
      <div class="tree-node-expander" (click)="node.toggleExpanded()">
        <mat-icon
          *ngIf="isExpanderVisible(node.children)">{{ node?.isExpanded ? "keyboard_arrow_down" : "keyboard_arrow_right" }}
        </mat-icon>
      </div>

      <div class="node-content-wrapper"
           [matTooltip]="node.data?.Name"
           (click)="node.mouseAction('click', $event)"
           (treeDrop)="node.onDrop($event)"
           [treeAllowDrop]="node.allowDrop"
           [treeDrag]="node"
           [treeDragEnabled]="node.allowDrag()">
        <div class="image-wrapper">
          <ng-container *ngIf="isVirtualRootFolder(node) else icon" >
            <mat-icon *ngIf="virtualRootFolder.icon.isRemoteMaterialIcon" class="material-icons-outlined" >{{ virtualRootFolder.icon.iconName }}</mat-icon>
            <mat-icon *ngIf="!virtualRootFolder.icon.isRemoteMaterialIcon" [svgIcon]="virtualRootFolder.icon.iconName"></mat-icon>
          </ng-container>
          <ng-template #icon>
            <mat-icon [svgIcon]="getEntityIcon(node)"></mat-icon>
          </ng-template>
        </div>
        <tree-node-content [node]="node" [index]="index"></tree-node-content>
      </div>
    </div>
  </ng-template>
</tree-root>

<context-menu #contextMenuRef menuClass="folders-context-menu">
  <ng-template contextMenuItem (execute)="createFolder($event)" [disabled]="isAddDisabled" [visible]="isVisible">
    <div class="folder-action">
      <mat-icon svgIcon="add-subfolder"></mat-icon>
      <span>{{ "folders.addSubfolder" | translate }}</span>
    </div>
  </ng-template>
  <ng-template contextMenuItem (execute)="editFolder($event)" [disabled]="isEditDisabled" [visible]="isVisible">
    <div class="folder-action">
      <mat-icon>edit</mat-icon>
      <span>{{ "folders.edit" | translate }}</span>
    </div>
  </ng-template>
  <ng-template contextMenuItem (execute)="deleteFolder($event)" [disabled]="isDeleteDisabled" [visible]="isVisible">
    <div class="folder-action">
      <mat-icon>delete</mat-icon>
      <span>{{ "folders.delete" | translate }}</span>
    </div>
  </ng-template>
</context-menu>
